import React from 'react';
import { ReactComponent as InfoIcon } from '../icons/icon_info_markets.svg';

export default function InfoMessage(props) {
    return (
        <div className="xs_infoMessage container">
            <div className="h-20 mx-2 my-1 grid grid-cols-12 items-center bg-cs7 rounded">
                <InfoIcon className="col-start-1 col-end-3 h-16 w-16 fill-cs3" />
                <span className="col-start-3 col-end-13 font-medium text-md text-cs3">{props.message}</span>
            </div>
        </div>
    );
}
